import i18n from '../../i18n';

export class Text {
  static get description(): string {
    return i18n._translate('iFIT members enjoy new content daily', {
      context: 'A paragraph telling the user that members of the app can get new content each day.',
    });
  }

  static get leadline(): string {
    return i18n._translate('Log in or sign up today', {
      context: 'A subtitle over a title indicating you can join for more content.',
    });
  }

  static get title(): string {
    return i18n._translate('Unlock thousands of Global Workouts and Studio Classes', {
      context: 'A heading over an image that prompts the user to click so they can get new content each day.',
    });
  }
}
